let tasksHelper = {};

tasksHelper._countTaskItems = function(show_hidden_tasks, uncompleted_items, completed_items, show_essential_tasks, show_recommended_tasks, show_information_only_tasks) {
  if (show_essential_tasks == null) { show_essential_tasks = true; }
  if (show_recommended_tasks == null) { show_recommended_tasks = true; }
  if (show_information_only_tasks == null) { show_information_only_tasks = true; }
  const tasks = completed_items.concat(uncompleted_items);
  return $.grep(tasks, function(task) {
    const event_type = task.event_type.trim().length ?
      task.event_type.parameterize('_')
    :
      'information_only';
    const event_filter = eval(`show_${event_type}_tasks`);
    if ((task.visible || show_hidden_tasks) && event_filter) { return task; }
  }).length;
};

const _convertToDate = date=> new Date(date);
const _createNewRecord = (task, date) =>
  ({
    date,
    requested_month: false,
    data: {
      benefit_events: {
        job_protected_benefits: [],
        paid_benefits: []
      },
      milestone_events: [],
      timeline_events: {
        completed_items: [],
        uncompleted_items: task
      }
    }
  })
;

const _dateRange = function(start_date, end_date, date_after){
  const current_date = new Date(start_date);
  const date_range = [];
  while (current_date < end_date) {
    date_range.push(new Date(current_date));
    current_date.setDate(current_date.getDate() + 1);
  }
  const dates = $.map(date_range, ( val, i ) => moment(val).format('YYYY-MM-DD'));
  if (date_after) {
    return dates.concat(moment(end_date).format('YYYY-MM-DD'));
  } else {
    return dates;
  }
};

tasksHelper._newCustomTasks = function(tasks, data){
  const start_date = _convertToDate(tasks[0].date);
  const end_date = _convertToDate(tasks[tasks.length-1].date);
  const current_date = _convertToDate(data.date);
  const new_tasks = [];
  if (current_date < start_date) {
    $.each(_dateRange(current_date, start_date, false), function(ind, val){
      let task;
      if (val === data.date) {
        task = [data];
      } else {
        task = [];
      }
      return new_tasks.push(_createNewRecord(task, val));
    });
    return new_tasks.concat(tasks);
  } else {
    $.each(_dateRange(end_date, current_date, true), function(ind, val){
      let task;
      if (val === data.date) {
        task = [data];
      } else {
        task = [];
      }
      return new_tasks.push(_createNewRecord(task, val));
    });
    return tasks.concat(new_tasks);
  }
};

export default tasksHelper;
